import * as React from "react";
const SvgMobileLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2H8v16h8zm-4 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2m1-12a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2z", clipRule: "evenodd" }));
export default SvgMobileLine;
